import { Grid } from "@mui/material";
import React from "react";
import ImageContainer from "./ImageContainer";
import DescriptionContainer from "./DescriptionContainer";
import DeleteContainer from "./DeleteListItem";
import { Link } from "react-router-dom";
import styled from "styled-components";

const WishListTile = (props) => {
  const { wishListItem = {} } = props;
  const { sku = "", product = {} } = wishListItem;
  const {
    imageUrl = {},
    brand = "",
    shortDescription = "",
    name = "",
    pdUrl = "",
    price = {},
  } = product;

  const Container = styled.div`

  display:flex;
  flex-direction:row;
  justify-content:flex-start;
  align-items:center;
  position:relative;
  width:100%;
  border:1px solid rgba(34, 34, 34, 0.12);
  padding-top:.5rem;
  padding-left:.5rem;
  margin-bottom:.5rem;
  
  
  
  `
  const ImageContainerr = styled.div`
  
  
  `
  const ImageDetailContainer = styled.div`
  
  `
  return (
    <React.Fragment>
      {Object.keys(wishListItem)?.length > 0 && (
        <Container >
          <ImageContainerr >
            <Link to={`${pdUrl}`}>
              <ImageContainer imageDetails={imageUrl} />
            </Link>
          </ImageContainerr>
          <ImageDetailContainer >
            <Link to={`${pdUrl}`} className="route-link-black">
              <DescriptionContainer
                brand={brand}
                title={name}
                price={price}
                description={shortDescription}
              />
            </Link>
          </ImageDetailContainer>
          <Grid >
            <DeleteContainer sku={sku} />
          </Grid>
        </Container>
      )}
    </React.Fragment>
  );
};

export default WishListTile;
